export default __webpack_public_path__ + "static/media/headshot-new.54b7e92a.png";